/**
 * Cliente API de recursos (Sprint 13 S13-24).
 *
 * Solo el CRUD basico para mantenedor en sa: list / get / crear /
 * editar. Las operaciones del ciclo de vida (confirmar-entrega,
 * cambiar-estado, asignar, devolver, suspender) viven en portal
 * bajo vista Comision/Tesorero — no se exponen desde aqui.
 */
import { apiFetch } from './client';

export type TipoRecurso =
  | 'llavero'
  | 'control_remoto'
  | 'citofonia'
  | 'acceso_app_wifi'
  | 'otro';

export type EstadoRecurso =
  | 'entregado'
  | 'devuelto'
  | 'perdido'
  | 'reemplazado';

export interface RecursoRead {
  id: string;
  lote_id: string;
  residente_actual_id: string | null;
  tipo: TipoRecurso;
  identificador: string;
  costo_reposicion: number;
  entregado_at: string;
  disponible_entrega_at: string | null;
  estado: EstadoRecurso;
  reemplaza_a_recurso_id: string | null;
  motivo_reemplazo: string | null;
  ingreso_vario_id: string | null;
  notas: string | null;
  creado_at: string;
  actualizado_at: string;
}

export interface RecursoUpdate {
  // Sprint 22: `residente_actual_id` ya NO se edita por PATCH (el backend
  // responde 422 con `extra="forbid"`). El portador se cambia con las
  // operaciones de flujo POST /recursos/{id}/asignar y /liberar, que validan
  // los invariantes y escriben el historial de asignaciones.
  costo_reposicion?: number;
  notas?: string | null;
  // Solo llaveros: se enruta al StockRecurso enlazado en el backend.
  serial_rfid?: string | null;
}

export interface ListRecursosFiltros {
  lote_id?: string;
  tipo?: TipoRecurso;
  estado?: EstadoRecurso;
  residente_actual_id?: string;
}

export function listRecursos(
  filtros: ListRecursosFiltros = {},
): Promise<RecursoRead[]> {
  const params = new URLSearchParams();
  if (filtros.lote_id) params.set('lote_id', filtros.lote_id);
  if (filtros.tipo) params.set('tipo', filtros.tipo);
  if (filtros.estado) params.set('estado', filtros.estado);
  if (filtros.residente_actual_id)
    params.set('residente_actual_id', filtros.residente_actual_id);
  const qs = params.toString();
  return apiFetch<RecursoRead[]>(`/recursos/${qs ? `?${qs}` : ''}`);
}

export function actualizarRecurso(
  id: string,
  data: RecursoUpdate,
): Promise<RecursoRead> {
  return apiFetch<RecursoRead>(`/recursos/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}
